import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

export interface PortalUnsavedChangesCloseData {
	stayOnPage: boolean;
}

@Component({
	selector: 'app-portal-unsaved-changes',
	templateUrl: './portal-unsaved-changes.component.html',
	styleUrls: ['./portal-unsaved-changes.component.scss'],
	standalone: false,
})
export class PortalUnsavedChangesComponent {
	constructor(public dialogRef: MatDialogRef<PortalUnsavedChangesComponent>) {
		this.dialogRef.addPanelClass('unsaved-changes-modal');
	}

	stay() {
		const data: PortalUnsavedChangesCloseData = {
			stayOnPage: true,
		};
		this.dialogRef.close(data);
	}

	closePortal() {
		const data: PortalUnsavedChangesCloseData = {
			stayOnPage: false,
		};
		this.dialogRef.close(data);
	}
}
